// export default OverviewCharts;
import * as React from "react"
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    alpha,
    useTheme
} from "@mui/material";
import {
    PieChart,
    ChartsTooltip,
    PieArcLabel,
} from "@mui/x-charts";

const OverviewCharts = ({
    reportData,
    categoryLabel,
    isService
}) => {
    const theme = useTheme();
    
    // Add some debugging
    console.log("OverviewCharts - reportData:", reportData);
    console.log("OverviewCharts - statusDistribution:", reportData?.statusDistribution);
    
    // Check if reportData exists
    if (!reportData) {
        return (
            <Typography variant="body1" color="text.secondary">
                No chart data available
            </Typography>
        );
    }

    return (
        <Grid container spacing={3}>
            {reportData.typeDistribution && reportData.typeDistribution.length > 0 ? (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                        }}
                    >
                        <CardContent>
                            <Typography variant="h6" gutterBottom fontWeight="bold">
                                {categoryLabel} Distribution
                            </Typography>
                            <Box sx={{ height: 300 }}>
                                <PieChart
                                    series={[
                                        {
                                            data: reportData.typeDistribution.map((item, index) => ({
                                                id: item.name || `category-${index}`,
                                                label: item.name || `${categoryLabel} ${index + 1}`,
                                                value: parseInt(item.count || item.value || 0),
                                            })),
                                            innerRadius: 40,
                                            outerRadius: 100,
                                            paddingAngle: 2,
                                            cornerRadius: 6,
                                            highlightScope: { faded: "global", highlighted: "item" },
                                            faded: {
                                                innerRadius: 30,
                                                additionalRadius: -30,
                                                color: "gray",
                                            },
                                            arcLabel: (item) => `${item.value}`,
                                            arcLabelMinAngle: 20,
                                        },
                                    ]}
                                    slotProps={{
                                        legend: {
                                            direction: "row",
                                            position: { vertical: "bottom", horizontal: "middle" },
                                            padding: 0,
                                            labelStyle: {
                                                fontSize: 12,
                                                fill: theme.palette.text.primary,
                                            },
                                        },
                                    }}
                                >
                                    <ChartsTooltip />
                                    <PieArcLabel />
                                </PieChart>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            ) : (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CardContent>
                            <Typography variant="body1" color="text.secondary">
                                No category distribution data available
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )}

            {reportData.statusDistribution && reportData.statusDistribution.length > 0 ? (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                        }}
                    >
                        <CardContent>
                            <Typography variant="h6" gutterBottom fontWeight="bold">
                                Status Distribution
                            </Typography>
                            <Box sx={{ height: 300 }}>
                                <PieChart
                                    series={[
                                        {
                                            data: reportData.statusDistribution.map((item) => ({
                                                id: item.status,
                                                label: item.label || item.status,
                                                value: parseInt(item.count || 0),
                                            })),
                                            innerRadius: 40,
                                            outerRadius: 100,
                                            paddingAngle: 2,
                                            cornerRadius: 6,
                                            highlightScope: { faded: "global", highlighted: "item" },
                                            faded: {
                                                innerRadius: 30,
                                                additionalRadius: -30,
                                                color: "gray",
                                            },
                                            arcLabel: (item) => `${item.value}`,
                                            arcLabelMinAngle: 20,
                                        },
                                    ]}
                                    slotProps={{
                                        legend: {
                                            direction: "row",
                                            position: { vertical: "bottom", horizontal: "middle" },
                                            padding: 0,
                                            labelStyle: {
                                                fontSize: 12,
                                                fill: theme.palette.text.primary,
                                            },
                                        },
                                    }}
                                >
                                    <ChartsTooltip />
                                    <PieArcLabel />
                                </PieChart>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            ) : (
                <Grid item xs={12} md={6}>
                    <Card
                        sx={{
                            background: alpha(theme.palette.background.paper, 0.8),
                            backdropFilter: "blur(8px)",
                            height: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CardContent>
                            <Typography variant="body1" color="text.secondary">
                                No status distribution data available
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>
    )
}

export default OverviewCharts;